module.exports = __webpack_public_path__ + "static/media/checkmark-circle-outline.71db3e39.svg";